module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"add":"Create jobs selection","h1":"New jobs selection","cancel":"Cancel"}}')
  delete Component.options._Ctor
}
